<template>
  <div class="homeItem" :style="{background: 'url('+background+')  no-repeat',minHeight:'620px'}">
    <div class="icon-title">
      <img v-if="icon" class="icon-img" :src="icon" />
       <p class="theme_font_color">{{title}}</p>
      </div>
    <slot></slot>
  </div>
</template>

<script>

export default {
  props: ["icon","title","background"],
  name: "homeItem",
  data() {
    return {
    };
  }
};
</script>
<style lang="less" scoped>
.homeItem {
  padding: 45px 20px;
  overflow: hidden;
  width: 100%;
  background-size: cover !important;
}
.icon-title {
  text-align: center;
  text-align: -webkit-center;
  .icon-img{
    width: 80px;
    height: 80px;
    margin-bottom: 12px;
  }
  p{
        
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #455A64;
    letter-spacing: 3px;
  }
}
@media only screen and (max-width: 620px) {
 
}
</style>
